import React from 'react'

const ConfirmationModal = ({ closeModal, title, handleSubmit }) => {
    return (
        <div
            className='modal show custom-modal-backdrop fade fixed top-0 left-0 hidden w-full h-full outline-none overflow-x-hidden overflow-y-auto'
            id='confirmationModal'
            tabIndex='-1'
            aria-labelledby='exampleModalCenterTitle'
            aria-modal='true'
            role='dialog'
            style={{ display: 'block' }}
        >
            <div className='modal-dialog max-w-[485px] modal-dialog-centered relative w-auto pointer-events-none'>
                <div className='modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding outline-none text-current'>
                    <div className='modal-body relative'>
                        <div className='p-6 border-b border-white-shade-100'>
                            {title}
                        </div>
                    </div>
                    <div className='p-6 pt-2 flex gap-6'>
                        <button
                            className='button secondary'
                            onClick={closeModal}
                        >
                            Cancel
                        </button>
                        <button
                            className='button primary mr-3'
                            onClick={handleSubmit}
                        >
                            Confirm
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ConfirmationModal
